import React from 'react';
import { Card, CardContent, ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataCard from './dataCard';
import { createTheme } from '@mui/material/styles';
import {
    List,
} from '@mui/material';
import Helper from '../../../utility/helper';
import { useThemeState } from '../../../hookState/ThemeState';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',

    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    listItemSubActContent: {
        padding: theme.spacing(0, 0),
    },
    paperContent: {
        // boxShadow:
        //     '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)', // made the changes for consistent styling
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',    
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        // backgroundColor: '#fff',
    },
    subPaperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 0, 1, 0),
        backgroundColor: '#fff',
    }
}));

const DataListRow = (props) => {
    const classes = useStyles();
    const { item, index } = props;
    const userInfo =  Helper.getStorage('userInfo');
    const isStartPast = (date) => { 
        if(date){
            var onlyStartTime = date.substring(date.length - 8); 
            if(onlyStartTime === "00:00:00"){
                const today = new Date();
                today.setDate(today.getDate() - 1);
                return new Date(date) < today;
            }else{
                const today = new Date();
                return new Date(date) < today;
            } 
        }
    };
    const themeState = useThemeState();

    // console.log("item", item); 
                       
    let isPastDate = false;
    if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) {
        isPastDate = false
    } else {
        if(item.actualData.endDateTime !== null){
            isPastDate =  isStartPast(item.actualData.endDateTime) 
        }else{
            isPastDate =  isStartPast(item.actualData.startDateTime) 
        }
    }
    return (
        <>
            <Card
                classes={{ root: classes.paperContent }}
                sx={{ width: '100%', mb: 2, backgroundColor: Helper.hexToRGB(themeState.primary.value, 0.08), opacity: isPastDate ?  '0.4' : '1', background: isPastDate ? 'lightgrey' : 'none'   }}>
                <CardContent sx={{ p: 2 }} className={classes.cardContent}>
                    <ListItem className={classes.listItemContent} >
                        <DataCard
                            classes={classes}
                            item={item}
                            index={index}
                            {...props}
                        />
                    </ListItem>

                    {/* {item.actualData.subActivities !== undefined && item.actualData.subActivities !== null && item.actualData.subActivities.length > 0 &&
                        <List>
                            {item.actualData.subActivities.map((values, inde) => {
                                return (
                                    <ListItem className={classes.listItemSubActContent} key={inde} sx={{ paddingBottom: '1px', paddingTop: '1px', mb: 2 }}>
                                        <DataCard
                                            hideCheckBox={true}
                                            classes={classes}
                                            items={values}
                                            index={index}
                                            {...props}
                                        />
                                    </ListItem>
                                )
                            })}
                        </List>
                    } */}

                </CardContent>
            </Card>
        </>

    );
};

export default DataListRow;
